<template>
    <div class="d-flex box mx-1 my-1 mx-lg-0">
        <div
            :class="[
                'box__left__container d-flex pl-2 py-1',
                {
                    'justify-content-center flex-column': !icon,
                    'align-items-center flex-row': icon,
                },
            ]"
        >
            <i v-if="icon" :class="[icon, 'mr-2']"></i>
            <span class="box__title">{{ title }}</span>
            <span v-if="!icon" class="box__subtitle">{{ subtitle }}</span>
        </div>
        <div
            class="d-flex justify-content-center align-items-center box__info ml-auto"
        >
            {{ info || '-' }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'SummaryBox',
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
        },
        icon: {
            type: String,
        },
        info: {
            type: Number | String,
        },
        success: {
            type: Boolean,
        },
        alert: {
            type: Boolean,
        },
    },
}
</script>

<style lang="scss" scoped>
.box {
    border-radius: 0.3rem;
    border: 1px solid #c2c5c9;
    width: 100%;
    height: 55px;
}

.box__left__container {
    width: 65%;
}

.box__title {
    font-size: 0.7rem;
    font-weight: 400;
    color: #a1a8af;
}

.box__subtitle,
i {
    font-size: 0.7rem;
    font-weight: 500;
    color: #009bdb;
}

.box__info {
    border-radius: 0.3rem;
    width: 35%;
    font-weight: 500;
    color: #009bdb;
    font-size: 1rem;
    background-color: #ebebeb;
}

@media (min-width: 1200px) {
    .box {
        width: 49%;
    }

    .box__info {
        font-size: 0.85rem;
    }
}

@media (min-width: 1700px) {
    .box__left__container {
        width: 75%;
    }

    .box__title,
    .box__subtitle {
        font-size: 0.75rem;
    }

    .fa,
    .fas,
    .far {
        font-size: 1rem;
    }
}
</style>
